import DGUtility from "../Model/DGUtility.m"

export type StyleModel = {
    container: object,
    light: object,
    dark: object,
}
export class Dashboard extends DGUtility {
    /*** Private Members ***/
    
    /*** Protected Members ***/
    
    /*** Private Methods ***/

    /*** Protected Methods ***/
    
    /**
     * Initialize and perform setup for the class
     */
    protected _init = () => {
        // Initialize or set all members based on constructor argument values 
    }
    
    /*** Public Methods ***/
    
    /**
     * Class constructor. Calls _init() on the superclass. Add parameters as needed
     */
    public constructor() {
        super()
        this._init()
    }
}

// Instantiate the VM and export the instance
const DashboardVM = new Dashboard()

export default DashboardVM
